var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "list-wrapper" },
    [
      _c("video-player", {
        staticClass: "video-player vjs-custom-skin",
        attrs: { options: _vm.playerOptions },
        on: {
          play: function($event) {
            return _vm.onplay($event)
          },
          pause: _vm.onpause,
          ended: _vm.onended
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "video_detail" }, [
        _c("p", { staticClass: "video_name" }, [_vm._v(_vm._s(_vm.name))]),
        _vm._v(" "),
        _vm.total_length && _vm.total_length != 0
          ? _c("p", { staticClass: "video_time" }, [
              _vm._v(
                "时长：" + _vm._s(_vm._f("formatSeconds")(_vm.total_length))
              )
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2924a087", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2924a087","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/video/video.vue
// module id = null
// module chunks = 